/* eslint global-require: "off" */
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    App: require('@/store/modules/app.module').default,
    Settings: require('@/store/modules/settings.module').default,
    Profile: require('@/store/modules/profile.module').default,
    Pages: { namespaced: true },
  },
  strict: process.env.NODE_ENV !== 'production',
  plugins: process.env.NODE_ENV !== 'production' ? [require('vuex/dist/logger')()] : [], // eslint-disable-line
});

export default store;

if (process.env.NODE_ENV !== 'production') {
  if (module.hot) {
    // accept actions and mutations as hot modules
    module.hot.accept([
      '@/store/modules/app.module',
      '@/store/modules/settings.module',
      '@/store/modules/profile.module',
    ], () => {
      // swap in the new actions and mutations
      store.hotUpdate({
        modules: {
          App: require('@/store/modules/app.module').default,
          Settings: require('@/store/modules/settings.module').default,
          Profile: require('@/store/modules/profile.module').default,
          Pages: { namespaced: true },
        },
      });
    });
  }
}
